import React, { MouseEventHandler, ReactNode } from 'react';
import classNames from 'classnames';
import UserAvatar, { AvatarSize } from 'Douleutaras/components/UserAvatar/UserAvatar';
import placeholderImg from 'Assets/layout/job/icon-extra-bid-avatar.svg';
import Tooltip from 'Douleutaras/components/Tooltip/Tooltip';

import './QuickButton.scss';

export interface QuickButtonProps {
  title: string | React.ReactElement;
  onClick?: MouseEventHandler;
  testId?: string;
  isAnchor?: boolean;
  href?: string;
  preview?: boolean;
  username?: string;
  mugshot?: string;
  subtitle?: string | React.ReactElement;
  disabled?: boolean;
  rightArrow?: boolean;
  selected?: boolean;
  icon?: string;
  tooltip?: ReactNode | string;
}

const QuickButton = ({ title,
                       onClick,
                       testId,
                       isAnchor = false,
                       href= '#',
                       preview,
                       username,
                       mugshot,
                       subtitle,
                       disabled,
                       rightArrow = true,
                       selected = false,
                       icon = '',
                       tooltip
                     }: QuickButtonProps) => {

  const WrapElement = ({ children, ...props }) => {
    const el = isAnchor ? <a {...props}>{children}</a> : <button {...props}>{children}</button>;

    return Boolean(tooltip) ? <Tooltip content={tooltip}>{el}</Tooltip> : el;
  };

  // Props that may or may not exist in WrapElement
  const conditionalProps = { href: undefined };
  if (isAnchor) {
    conditionalProps.href = href;
  }

  return (
    <WrapElement
      disabled={disabled}
      styleName={classNames({
        'quick-button': true,
        'quick-button--preview': preview === true,
        'quick-button--square' : subtitle,
        'quick-button--right-arrow': rightArrow,
        'quick-button--selected' : selected,
        'quick-button--icon-left': icon,
        disabled
      })}
      type="button"
      data-testid={testId}
      onClick={onClick}
      {...conditionalProps}>
      {preview &&
        <span styleName="quick-button__left">
          <UserAvatar mugshot={username ? mugshot : placeholderImg } username={username} size={AvatarSize.SMALL} />
        </span>
      }
      {icon && icon !== '' &&
        <span styleName="quick-button__icon-left">
          <img styleName="quick-button__icon" src={icon} />
        </span>
      }
      <span styleName={classNames({ 'quick-button__title': true, 'quick-button__title--selected': selected })}>{title}</span>
      {subtitle &&
        <span styleName="quick-button__subtitle">{subtitle}</span>
      }
      { Boolean(selected) &&
        <span className="dashicon dashicon-done" styleName="selected-icon" />
      }
    </WrapElement>
  );
};

export default QuickButton;
